'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg12 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 12, height: 13, viewBox: "0 0 12 13", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.92132 2.30362C3.24538 1.92672 3.81361 1.88388 4.19051 2.20793L8.10108 5.5702C8.11161 5.57926 8.12223 5.58838 8.13292 5.59756C8.30943 5.74917 8.5066 5.91852 8.65206 6.08431C8.82307 6.27919 9.02931 6.58536 9.02931 7.01089C9.02931 7.43643 8.82307 7.7426 8.65207 7.93749C8.50661 8.10327 8.30945 8.27262 8.13294 8.42423C8.12224 8.43342 8.11162 8.44254 8.1011 8.45159L4.22848 11.7813C3.85158 12.1054 3.28334 12.0625 2.95928 11.6856C2.63523 11.3087 2.67806 10.7405 3.05496 10.4164L6.92758 7.08673C6.9591 7.05963 6.98835 7.03447 7.01565 7.0109C6.98835 6.98734 6.9591 6.96218 6.92758 6.93508L3.01701 3.57281C2.64011 3.24875 2.59727 2.68052 2.92132 2.30362Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg12;
//# sourceMappingURL=12.js.map
